/**
 * Endereço do app. Ele já esteve em outros endereços: quem abre um endereço
 * antigo (favorito, atalho, casca desktop 0.2.0) primeiro ENVIA o que ficou
 * salvo só neste computador — o banco local e a fila de gravações pertencem ao
 * endereço (origem) — e só então vai para o endereço atual. Sem internet, ou com
 * algo ainda na fila, continua no endereço antigo normalmente e tenta de novo na
 * próxima abertura (nada se perde).
 */
import { sync } from './nucleo/cliente'

export const ENDERECO = 'climbogroultra.werc.com.br'
const ANTIGOS = ['novo.werc.com.br']

export const emEnderecoAntigo = (): boolean => ANTIGOS.includes(location.hostname)

/** Envia a fila e vai para o endereço atual. Devolve false se precisou ficar. */
export async function irParaEnderecoAtual(): Promise<boolean> {
  try {
    await Promise.race([sync.agora(), new Promise((_, falhar) => setTimeout(() => falhar(new Error('tempo')), 20_000))])
    const e = await sync.estado()
    if (e.pendentes > 0) return false
  } catch {
    return false
  }
  location.replace(`https://${ENDERECO}${location.pathname}${location.search}${location.hash}`)
  return true
}
